export default __webpack_public_path__ + "static/media/bici.ce922142.svg";